import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchData, fetchPieChartData, fetchdashData, fetchChartData, fetchfundPieChartData, fetchDonorChartData, fetchdonPieChartData, fetchfundDonorChartData } from '../reduxactions/mobileactions/MobDashboardAction';
import useEffectOnce from '../hooks/useEffectOnce';
import { RootState } from '../reducers';
import { Panel } from 'primereact/panel';
import { Chart } from 'primereact/chart';
import { useLocation, useNavigate, useParams } from 'react-router-dom';


const MobFundDash = () => {
    const [globalFilter, setGlobalFilter] = useState('')

    const dispatch = useDispatch();
    const { uid } = useParams();


    const usertyped = useSelector((state: RootState) => state.mob.data);
    console.log("usertype", usertyped)

    const mobiledata = useSelector((state: RootState) => state.mob.dashdata);
    console.log("mobiledata", mobiledata)

    const piechartData = useSelector((state: RootState) => state.mob.pieChartData);
    console.log("piechartData", piechartData)
    const fundpieChartData = useSelector((state: RootState) => state.mob.fundpieChartData);

    const funChartData = useSelector((state: RootState) => state.mob.funChartData);
    const fundpiechartOptions = useSelector((state: RootState) => state.mob.fundpiechartOptions);
    const funchartOptions = useSelector((state: RootState) => state.mob.fundChart);



    const handleLogout = () => {
        window.sessionStorage.removeItem('usertype');
    };
    useEffectOnce(() => {
        const fetchDataAsync = async () => {
            try {

                await dispatch(fetchData(uid) as any);
                await dispatch(fetchdashData(uid) as any);
                await dispatch(fetchfundPieChartData(uid) as any);
                await dispatch(fetchfundDonorChartData(uid) as any);





            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchDataAsync();
    }, [dispatch]);


    return (
        <div>
            <div className="content-wrapper">
                <section className="content">
                    <div className="container-fluid">

                        <section className="content">
                            {mobiledata.map((response: any) =>
                                <div className="grid">
                                    <div className="col-4">
                                        <div className="bg-red">
                                            <div className="surface-0 shadow-2 p-3 border-1 border-50 border-round bg-bluegray-200">
                                                <div className="flex justify-content-between mb-3">
                                                    <div>
                                                        <span className="block text-500 font-medium mb-3 text-900">FundManagers</span>
                                                        <div className="text-900 font-medium text-xl">{response.fundmanagers}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="surface-0 shadow-2 p-3 border-1 border-50 border-round bg-green-200 ">
                                            <div className="flex justify-content-between mb-3">
                                                <div>
                                                    <span className="block text-500 font-medium mb-3 text-900">Donations</span>
                                                    <div className="text-900 font-medium text-xl">{response.donations}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="surface-0 shadow-2 p-3 border-1 border-50 border-round bg-yellow-400">
                                            <div className="flex justify-content-between mb-3">
                                                <div>
                                                    <span className="block text-500 font-medium mb-3 text-900">Needs</span>
                                                    <div className="text-900 font-medium text-xl">{response.needs}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="grid">
                                <section className="col-6">
                                    <div className="box box-danger">
                                        <Panel header="Donations" toggleable>
                                            <Chart type="pie" style={{ height: '450px' }} data={fundpieChartData} options={fundpiechartOptions} />
                                        </Panel>
                                    </div>
                                </section>
                                <section className="col-6">
                                    <div className="box box-danger">
                                        <Panel header="Fund Manager " toggleable>
                                            <Chart type="bar" style={{ height: '450px' }} data={funChartData} options={funchartOptions} />
                                        </Panel>
                                    </div>
                                </section>

                            </div>

                        </section>


                    </div>
                </section>
            </div>
        </div>
    )
}
export default MobFundDash






